import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { AxiosPromise } from '../../utils/axios.promise';

@Component
export default class HotBlogsList extends Vue {
    public title: string = 'HotBlogsList';
    public userInfoService = new UserInfoDelegate();
    public configs = new CommonConfig();
    public listData: { 'id': number, 'title': string; 'view': number; 'img': string }[] = [];
    @Prop({ default: null })
    public excludeId!: number;

    public async mounted() {
        const user = this.userInfoService.Data;
        const apiHost = this.configs.cmisapiHost;
        // if (user && user.cims_uid && this.excludeId) {
        // const user = {
        //     cims_uid: 28
        // };
        const recommendList = await AxiosPromise.postUrlEncode(`${apiHost}/blogArticle/selectRecommendByAgentId`, {
            userId: 0,
            excludeId: this.excludeId,
            is_show_web: 1
        });
        const placeHolder = this.configs.housePicPlaceHolder;
        if (recommendList
            && recommendList.status === 200
            && recommendList.data.data
            && recommendList.data.data.length) {
            this.listData = recommendList.data.data.slice(0, 5).map((v: any) => {
                return {
                    'title': v.title,
                    'view': v.readCount + v.initReadCount,
                    'img': v.images ? v.images : placeHolder,
                    'id': v.id
                };
            });

        }
        // }
    }
}
